import { flatten, lt, map, pathOr, pipe, pluck, reduce, sum, values, } from "ramda";
import formatMoney from "sig/formatters/money";
function calculateSubtotalForMods(item) {
    return pipe(pluck("mods"), flatten, map(function (mod) { return ({
        name: mod.name,
        subtotal: mod.price * item.quantity,
    }); }))(item.selectedModifiers);
}
// Client side tax calculation will soon be deprecated.
// See interfaces/caltulate_totals for backend calculation API.
function calculateTaxesForMods(item) {
    return pipe(pluck("mods"), flatten, map(function (mod) {
        return mod.taxRate
            ? mod.price * parseFloat(mod.taxRate.percentageRate) * item.quantity
            : 0;
    }), sum)(item.selectedModifiers);
}
function calculateSubtotalForSides(item) {
    return map(function (side) { return ({
        name: side.name,
        subtotal: side.price * item.quantity,
    }); }, item.selectedSides);
}
// Client side tax calculation will soon be deprecated.
// See interfaces/caltulate_totals for backend calculation API.
function calculateTaxesForSides(item) {
    return pipe(map(function (side) {
        return side.price * parseFloat(side.taxRate.percentageRate) * item.quantity;
    }), flatten, sum)(item.selectedSides);
}
function formatPrice(priceCents) {
    return formatMoney(priceCents * 0.01);
}
function formatSignedPrice(priceCents) {
    var formattedPrice = formatPrice(priceCents);
    if (lt(priceCents, 0)) {
        return formattedPrice;
    }
    return "+" + formattedPrice;
}
function getItemDetailedTotals(item) {
    var base = item.quantity * item.price;
    var mods = calculateSubtotalForMods(item);
    var sides = calculateSubtotalForSides(item);
    return {
        base: base,
        mods: mods,
        sides: sides,
    };
}
function getItemSubtotal(item) {
    var detailed = getItemDetailedTotals(item);
    return pipe(values, map(function (detail) {
        if (detail instanceof Array) {
            return sum(pluck("subtotal", detail));
        }
        return detail;
    }), sum)(detailed);
}
function getItemTotals(item) {
    var subtotal = getItemSubtotal(item);
    // Client side tax calculation will soon be deprecated.
    // See interfaces/caltulate_totals for backend calculation API.
    var tax = pathOr(0, ["taxRate", "percentageRate"], item) *
        (item.quantity * item.price);
    tax += calculateTaxesForMods(item);
    tax += calculateTaxesForSides(item);
    // @todo add modifier and sides totals and taxes here
    return { subtotal: subtotal, tax: tax };
}
function getTotals(items, deliveryFee, deliveryFeeTaxRate) {
    if (deliveryFee === void 0) { deliveryFee = 0; }
    if (deliveryFeeTaxRate === void 0) { deliveryFeeTaxRate = 0; }
    var deliveryFeeTaxRateNum = typeof deliveryFeeTaxRate === "string"
        ? parseFloat(deliveryFeeTaxRate)
        : deliveryFeeTaxRate;
    var deliveryTax = deliveryFee * deliveryFeeTaxRateNum;
    return reduce(function (acc, item) {
        var _a = getItemTotals(item), itemSubtotal = _a.subtotal, itemTax = _a.tax;
        return {
            subtotal: acc.subtotal + itemSubtotal,
            tax: acc.tax + itemTax,
        };
    }, { subtotal: 0, tax: deliveryTax }, items);
}
export { formatSignedPrice, formatPrice, getTotals, getItemDetailedTotals, getItemTotals, getItemSubtotal, };
export default getTotals;
